import template from './alertMessage.template.html';

export default {
  template,
  bindings: {
    messages: '<',
    icon: '<',
    class: '<',
    actionUrl: '<',
    actionTarget: '<',
    actionIcon: '<',
    actionTitle: '<',
    image: '<',
    isProcessing: '<'
  },
  controller: class controller {
    constructor($mdMedia) {
      'ngInject';

      const ctrl = this;
      ctrl.$mdMedia = $mdMedia;

      ctrl.initialize = () => {
        ctrl.messages = ctrl.messages || [];
        ctrl.icon = ctrl.icon || 'info';
        ctrl.class = ctrl.class || 'info';
        ctrl.actionUrl = ctrl.actionUrl || '';
        ctrl.actionTarget = ctrl.actionTarget || '_self';
        ctrl.actionIcon = ctrl.actionIcon || 'link';
        ctrl.actionTitle = ctrl.actionTitle || 'N/A';
        ctrl.isProcessing = ctrl.isProcessing || false;
        ctrl.image = ctrl.image || null;
        ctrl.showMore = false;
      };

      ctrl.toggleShowMore = () => {
        ctrl.showMore = !ctrl.showMore;
      };

      ctrl.showButton = () => ctrl.actionUrl !== '';

      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
